module.exports = "../../../../platform/assets/pageMainIcon/industry_jichudanganlei4.svg";